import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import axios from 'axios'
import { apiRequest } from '../../apiServices/allApi';


function Permissions() {
    let { id } = useParams();
    const [user, setUser] = useState();
    const [set, setSet] = useState();
    const [permissions, setPermissions] = useState([]);
    const access_token = localStorage.getItem("token")
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    if (nodeMode === "development") {
      var baseUrl = beckendLocalApiUrl;
    } else {
      baseUrl = beckendLiveApiUrl;
    }

    // const headers = {
    //     Authorization: `Bearer ${access_token}`
    // }
    // const getUser = () => {
    //     axios.get(baseUrl+`admin/get_user_data/${id}`, { headers })
    //         .then((res) => {
    //             if (res.data.Permissions) {
    //                 if (res.data.Permissions.length) {
    //                     setSet(true);
    //                 }
    //             }
    //             setUser(res.data)
    //         }).catch((e) => {
    //             if (e.response.status == 401) {
    //                 localStorage.removeItem('token');
    //             }
    //         })
    // }
    const headers = {
        Authorization: `Bearer ${access_token}`
    }
        
    const getUser = async () => {

          try {
            const res = await apiRequest(  `admin/get_user_data/${id}`,"GET",null,headers);
            if (res.data.Permissions) {

                if (res.data?.Permissions?.length) {
                    setSet(true);
                    setPermissions(res.data.Permissions);
                }
            }
            setUser(res.data)
          } catch (e) {
            if (e.res?.status == 401) {
                localStorage.removeItem('token');
            }
          } finally {
            // setLoading(false)
          }
        };


    // const grantAccess = () => {
    //     try {
    //         axios.patch(baseUrl+`admin/agent/permission/${id}`,{} , { headers })
    //             .then((res) => {
    //                 getUser();
    //             }).catch((e) => {
    //                 if (e.response.status == 401) {
    //                     localStorage.removeItem('token');
    //                 }
    //             })
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    const grantAccess = async () => {
       
          try {
            const res = await apiRequest(  `admin/agent/permission/${id}`,"PATCH",null,headers);
            getUser();

    
          } catch (e) {
            if (e.response?.status == 401) {
                localStorage.removeItem('token');
            }
          } finally {
            // console.log(error)
          }
        };



    // const giveAccess = (Status,ID) => {
    //     try {
    //         axios.post(baseUrl+`admin/agent/permission/nested/${ID}`,{
    //             Status
    //         }, { headers }) 
    //             .then((res) => {
    //                 getUser();
    //             }).catch((e) => {
    //                 if (e.response.status == 401) {
    //                     localStorage.removeItem('token');
    //                 }
    //             })
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    const giveAccess = async (value, ID, permission) => {
        const payload = (permission === 'withdrawmin' || permission === 'withdrawmax') ? {value} : {Status: value};
        try {
          const res = await apiRequest(  `admin/agent/permission/nested/${ID}` ,"POST",payload,headers);
          if (res) {
            // Update local state immediately for better UX
            setPermissions(prev => prev.map(p => p._id === ID ? (permission === 'withdrawmin' || permission === 'withdrawmax' ? {...p, Value: value} : {...p, Status: value}) : p));
            getUser(); // Refresh data from server
          }
        } catch (e) {
            if (e.response?.status == 401) {
         localStorage.removeItem('token');
   }
        } finally {
        //   console.log(error)
        }
      };

    const handleInputChange = (id, value, permission) => {
        setPermissions(prev => prev.map(p => p._id === id ? (permission === 'withdrawmin' || permission === 'withdrawmax' ? {...p, Value: value} : {...p, Status: value}) : p));
    };

    useEffect(() => {
        getUser();
    }, [])

    return (
        <div className="row ">
            <div className="col-12 grid-margin">
                {user && <div className="card">
                    {!Boolean(set) && <button type="button" className="btn btn-success btn-lg" onClick={grantAccess}>Grant Permissions</button>}
                    {Boolean(set) && <div className='card-body'>
                        <h4 className="card-title">Pages Permission</h4>
                        <ul className="list-group list-group-flush">
                            {user.Permissions?.map((item, key) =>
                                <li key={key} className="list-group-item">
                                    <div>
                                        <div>
                                            {item.Permission}
                                        </div>
                                        <div>
                                            {item.Permission === 'withdrawmin' || item.Permission === 'withdrawmax' ? (
                                                <div className="d-flex">
                                                    <input
                                                        type="number"
                                                        value={permissions.find(p => p._id === item._id)?.Value || item.Value }
                                                        onChange={(e) => handleInputChange(item._id, parseInt(e.target.value), item.Permission)}
                                                        className="form-control"
                                                        min="0"
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary ml-2"
                                                        onClick={() => giveAccess(permissions.find(p => p._id === item._id)?.Value || item.Value, item._id, item.Permission)}
                                                    >
                                                        Submit
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="custom-control custom-switch">
                                                    <input type="checkbox" checked={item.Status} onChange={(e)=>giveAccess(!(item.Status),item._id)} className="custom-control-input" id={item.Permission} />
                                                    <label className="custom-control-label" htmlFor={item.Permission}>Allow to access</label>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>}
                </div>}
            </div>
        </div>
    )
}

export default Permissions